import { CACHE_KEYS } from "@libs/swr";
import type { DealerConfig } from "@lyteflo/types";
import { getDealerConfiguration } from "@services/configuration";
import useSWR from "swr";

export const useDealerConfig = (dealerId: string | null | undefined) => {
  const key = dealerId ? `${CACHE_KEYS.DEALER_CONFIG}-${dealerId}` : null;
  const { data, error, isLoading } = useSWR<DealerConfig>(key, () =>
    getDealerConfiguration(dealerId as string),
  );
  return { data, error, isLoading };
};
